// extracted by mini-css-extract-plugin
export var section = "styles-module--section--cQykw";
export var container = "styles-module--container--r3eH1";
export var inner = "styles-module--inner--tjihh";
export var localeWrap = "styles-module--localeWrap--1VrnP";
export var title = "styles-module--title--31Kam";
export var subtitle = "styles-module--subtitle--26gYX";